export enum AttendanceMutations {
  RESET = "RESET",
  SET_ATTENDANCE_LIST = "SET_ATTENDANCE_LIST",
  SET_COURSE_ATTENDANCE_LIST = "SET_COURSE_ATTENDANCE_LIST",
  SET_DAY_ATTENDANCE_LIST = "SET_DAY_ATTENDANCE_LIST",
  SET_DAY_ATTENDANCE_ITEM = "SET_DAY_ATTENDANCE_ITEM",
  SET_CURRENT_DAY = "SET_CURRENT_DAY",
}
